import React from 'react';
import {Header,Item, Label,  Breadcrumb, Table, Transition, Icon, Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Popup} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';


const ReporteExamen=({ id, ajaxCallInProgress, errors=[], strings, reporte, resultadosExamen,download, onChange, onShowExamen})=>{

    

	return (
        <Container>
         <Segment>
                    <Form>
                         <Form.Field >            
                              <Input 
                                    placeholder={strings?strings["empresa"]:""} 
                                    name="emp"
                                    onChange={onChange}
                                    value={reporte.emp}
                                    icon='edit'/>
                            </Form.Field>
                    </Form>    
            </Segment>
          
        {resultadosExamen.examenResultado.length>0?
       
            
                <Container>
         
                    <Segment clearing>
                        <Header floated='left'>
                           Resultados
                        </Header>
                        <Header floated='right'>
                          reporte<Icon color="green" size="small" link onClick={download} name='file excel' />
                        </Header>
                      </Segment>
         
                    <Table celled>
                        <Table.Header>
                        <Table.Row>
                                <Table.HeaderCell>{strings?strings["alumno"]:""}</Table.HeaderCell>  
                                 <Table.HeaderCell>{strings?strings["empresa"]:""}</Table.HeaderCell>  
                                 <Table.HeaderCell>{strings?strings["mail"]:""}</Table.HeaderCell>  
                            {resultadosExamen.examenes.map(examen =>
                                
                                <Table.HeaderCell textAlign="right">{examen.descripcion}</Table.HeaderCell>
                             
                            )}
                        
                        </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            
                            {resultadosExamen.examenResultado.map(examen =>
                            
                                <Table.Row>
                                    <Table.Cell>
                                        {examen.usuario}
                                    </Table.Cell>
                                     <Table.Cell>
                                        {examen.empresa}
                                    </Table.Cell>
                                     <Table.Cell>
                                        {examen.mail}
                                    </Table.Cell>
                        
                                    {resultadosExamen.examenes.map(examenTitulos =>
                                        <Table.Cell  textAlign="right">                        
                                        {examen.resultados.map(calificacion =>
                                         
                                            <>
                                                {calificacion.idForm == examenTitulos.id?
                                                    <>               
                                                                   
                                                    <Popup
                                                        trigger={
                                                            <Icon name='eye' link 
                                                            onClick={()=>onShowExamen(calificacion.id)} 
                                                            size="large" color="blue"  />
                                                                
                                                            
                                                        }
                                                        content={(((calificacion.correctPoints)*100)/Number(calificacion.totalPoints)).toFixed(2)+"%"}
                                                      />
                                                    {(((calificacion.correctPoints)*100)/Number(calificacion.totalPoints)).toFixed(2)+"%"}
                                                    </>    
                                                :
                                                    ""
                                                }
                                            </>
                                            
                                        )}
                                            
                                        </Table.Cell>                                          
                                        )}
                                    </Table.Row>    
                            
                            )}
                             
                        </Table.Body>    
                    </Table>
        
        
        
                </Container>
        
                :
        
                "Seleccióne un curso"
        
            }        
        
        
        </Container>
	);
};



export default ReporteExamen;